import React from 'react';
import { personalInfo } from '../data/mock';
import { Github, Linkedin, Mail, FileText } from 'lucide-react';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-name">{personalInfo.name}</h1>
            <h2 className="hero-title">{personalInfo.title}</h2>
            <p className="hero-tagline">{personalInfo.tagline}</p>
            {personalInfo.cta && (
              <div className="hero-cta">
                <span className="cta-badge">Available for Internships</span>
                <p className="cta-text">{personalInfo.cta}</p>
              </div>
            )}
            
            <div className="hero-links">
              <a href={personalInfo.resumeUrl} download className="hero-link">
                <FileText size={20} />
                <span>Resume</span>
              </a>
              <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" className="hero-link">
                <Github size={20} />
                <span>GitHub</span>
              </a>
              <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="hero-link">
                <Linkedin size={20} />
                <span>LinkedIn</span>
              </a>
              <a href={`mailto:${personalInfo.email}`} className="hero-link">
                <Mail size={20} />
                <span>Email</span>
              </a>
            </div>
          </div>
          
          <div className="hero-image-container">
            <div className="hero-image">
              <img src={personalInfo.profileImage} alt={personalInfo.name} />
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-divider"></div>
    </section>
  );
};

export default Hero;